import { ReactElement } from 'react';

import { ConfidentialityMode } from '@dreryk/egabinet-personnel-frontend-api';

import { Modal, ModalCancelButton, ModalCloseButton, ModalWidth } from '@dreryk/react-components';

import { practitionersTranslationKeys } from '../../../../../../../translations';
import { DefaultConfidentialityModeUpdateForm } from '../form/DefaultConfidentialityModeUpdateForm';

import { DefaultConfidentialityModeHistoricalUpdateModalConfirmButton } from './DefaultConfidentialityModeHistoricalUpdateModalConfirmButton';
import { DefaultConfidentialityModeNonHistoricalUpdateModalConfirmButton } from './DefaultConfidentialityModeNonHistoricalUpdateModalConfirmButton';

type DefaultConfidentialityModeUpdateModalProps = Readonly<{
   mode: ConfidentialityMode;
   practitionerId: number;
   onCancel: VoidFunction;
   onSuccess: VoidFunction;
}>;

export const DefaultConfidentialityModeUpdateModal = (
   props: DefaultConfidentialityModeUpdateModalProps
): ReactElement => {
   return (
      <Modal
         testId={'defaultConfidentialityModeUpdateModal'}
         title={practitionersTranslationKeys.defaultConfidentialResourceModeUpdate.modalTitle}
         width={ModalWidth.NORMAL}
         onCloseRequest={props.onCancel}
         visible
         animateVisibility
      >
         <DefaultConfidentialityModeUpdateForm>
            {({ handleSubmit, formState, watch }) => {
               const scope = watch('scope');

               return (
                  <>
                     {scope === 'NEW_DATA_ONLY' ? (
                        <DefaultConfidentialityModeNonHistoricalUpdateModalConfirmButton
                           handleSubmit={handleSubmit}
                           mode={props.mode}
                           practitionerId={props.practitionerId}
                           onSuccess={props.onSuccess}
                        />
                     ) : null}
                     {scope === 'ALL_DATA' ? (
                        <DefaultConfidentialityModeHistoricalUpdateModalConfirmButton
                           handleSubmit={handleSubmit}
                           mode={props.mode}
                           practitionerId={props.practitionerId}
                           onSuccess={props.onSuccess}
                        />
                     ) : null}
                     <ModalCancelButton onClick={props.onCancel} shouldConfirmExit={formState.isDirty} />
                     <ModalCloseButton onClick={props.onCancel} shouldConfirmExit={formState.isDirty} />
                  </>
               );
            }}
         </DefaultConfidentialityModeUpdateForm>
      </Modal>
   );
};
